import { filterObject } from 'legacy/utils/filterObject'

import { sanitizeEquipmentQueryString } from './sanitizeEquipmentQueryString'
import { sanitizeLanesQueryString } from './sanitizeLanesQueryString'

const filtersTransformationCallbacks = {
  lanes: sanitizeLanesQueryString,
  equipment_type: sanitizeEquipmentQueryString,
}

function isAllowed(blacklist) {
  return someKey => !blacklist.includes(someKey)
}

function sanitizeFiltersQuery(data = {}, blacklist = [], filterOnly = false) {
  const sanitizedData = filterObject(data, isAllowed(blacklist))

  if (filterOnly) {
    return sanitizedData
  }

  const propsPendingTransform = Object.keys(filtersTransformationCallbacks)

  return Object.keys(sanitizedData).reduce((result, someProperty) => {
    const needsTransformation = propsPendingTransform.includes(someProperty) ? true : false
    const currentValue = sanitizedData[someProperty]

    return {
      ...result,
      [someProperty]: needsTransformation
        ? filtersTransformationCallbacks[someProperty](currentValue)
        : currentValue,
    }
  }, {})
}

export { sanitizeFiltersQuery }
